import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TopBar = ({ handleLogout, darkMode }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="bg-gray-800 p-4 text-white flex justify-between items-center relative">
      <div className="flex items-center space-x-6">
        <Link to="/" className="text-white text-lg font-bold">
          Mouum.NET
        </Link>
        <Link to="/blog" className="text-white hover:underline">
          Blog
        </Link>

        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="text-white hover:underline focus:outline-none"
          >
            Meshtastic ▾
          </button>
          {dropdownOpen && (
            <div className="absolute mt-2 bg-white text-black rounded shadow-lg z-10">
              <Link
                to="/meshtastic/nodes"
                className="block px-4 py-2 hover:bg-gray-200"
                onClick={() => setDropdownOpen(false)}
              >
                Nodes
              </Link>
              <Link
                to="/meshtastic/messages"
                className="block px-4 py-2 hover:bg-gray-200"
                onClick={() => setDropdownOpen(false)}
              >
                Meldinger
              </Link>
              <Link
                to="/meshtastic/messages?channel=Vardal"
                className="block px-4 py-2 hover:bg-gray-200"
                onClick={() => setDropdownOpen(false)}
              >
                Meldinger - Vardal
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
